'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:ui:toast');
}

var _invoke = require('../invoke');

/**
 * toast 弹窗
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof ui
 * @static
 * @name toast
 * @param {String} message 弹窗信息
 * @param {Number} [time] toast 持续时间，单位 `ms`，可选，默认 3000
 * @return {Undefined}
 * @example
 *  hbnb.ui.toast('message', 1000);
 */

module.exports = function(message, time) {
    if (process.env.NODE_ENV !== 'production') {
        debug('message is %s', message);
        debug('time is %s', time);
    }

    time = time || 3000;

    _invoke('ui', 'toast', {
        message: message,
        time: time
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/ui/toast.js
// module id = 656
// module chunks = 0